import { useEffect, useState } from "react";
import { Bell, Check } from "lucide-react";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "../components/ui/popover";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function NotificationBell({ testid = "notification-bell" }) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const refresh = () => api.get("/notifications").then((r) => {
    setItems(r.data.items || []);
    setUnread(r.data.unread || 0);
  }).catch(() => {});

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 30000);
    return () => clearInterval(id);
  }, []);

  const markRead = async (n) => {
    if (n.read_at) return;
    await api.post(`/notifications/${n.id}/read`);
    refresh();
  };
  const markAll = async () => {
    await api.post("/notifications/read-all");
    refresh();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button data-testid={testid} variant="ghost" className="relative h-10 w-10 p-0 hover:bg-mb-surface2">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span data-testid="notification-unread-badge"
              className="absolute -top-0.5 -right-0.5 h-4 min-w-[16px] px-1 rounded-full bg-teal-500 text-zinc-950 text-[10px] flex items-center justify-center font-bold">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 bg-mb-surface border-mb-border text-white p-0">
        <div className="px-4 py-3 border-b border-mb-border flex items-center justify-between">
          <div className="text-sm font-medium">Notifications</div>
          {unread > 0 && (
            <button onClick={markAll} data-testid="notification-mark-all"
              className="text-xs text-teal-400 hover:text-teal-300 inline-flex items-center gap-1">
              <Check className="h-3 w-3" /> Mark all read
            </button>
          )}
        </div>
        <ul className="max-h-96 overflow-y-auto divide-y divide-mb-border">
          {items.length === 0 && (
            <li className="px-4 py-8 text-sm text-mb-fg2 text-center">No notifications yet.</li>
          )}
          {items.map((n) => (
            <li key={n.id} onClick={() => markRead(n)}
              data-testid={`notification-item-${n.id}`}
              className={`px-4 py-3 cursor-pointer hover:bg-mb-surface2 ${n.read_at ? "opacity-60" : ""}`}>
              <div className="flex justify-between items-start gap-3">
                <div className="min-w-0">
                  <div className="text-sm text-white truncate">{n.title}</div>
                  <div className="text-xs text-mb-fg2 mt-0.5">{n.body}</div>
                </div>
                {!n.read_at && <span className="h-2 w-2 rounded-full bg-teal-400 mt-1.5 shrink-0" />}
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-600 mt-2">{n.type}</div>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
